import { Stack } from '@mui/material';
import { useFormikContext } from 'formik';
import { useEffect, useMemo, useState } from 'react';
import { useAppSelector, useAppDispatch } from 'src/app/hooks';
import SectionKeywordHashtag from 'src/components/ModalManageObjectByGroup/components/SectionKeywordHashtag';
import SectionSocialProfile from 'src/components/ModalManageObjectByGroup/components/SectionSocialProfile';
import {
  reducerUpdateTempSelectedKeywords,
  reducerUpdateTempSelectedSocialProfiles
} from 'src/features/customDashboard';
import { IObject } from 'src/models/objectManagement';
import { IFormValues } from './ModalCreateCustomDashboard';

const SelectObjectSection = () => {
  const { values } = useFormikContext<IFormValues>();
  const dispatch = useAppDispatch();
  const {
    tempSelectedSocialProfiles: selectedSocialProfileIds,
    tempSelectedKeywords: selectedKeywordIds
  } = useAppSelector((state) => state.storeCustomDashboard);
  const { objectList: objectListData, selectedObjectType } = useAppSelector(
    (state) => state.objectManagement
  );

  const getActiveSocialProfileIds = () => {
    return values.objects
      .filter((obj) => obj.streamType === 'account')
      .map((obj) => obj.id);
  };

  const getActiveKeywordIds = () => {
    return values.objects
      .filter((obj) => obj.streamType === 'keyword')
      .map((obj) => obj.id);
  };

  useEffect(() => {
    dispatch(
      reducerUpdateTempSelectedSocialProfiles(getActiveSocialProfileIds())
    );
    dispatch(reducerUpdateTempSelectedKeywords(getActiveKeywordIds()));
  }, [values.objects]);

  const objectList = objectListData.data;

  const filteredObjectsByType = useMemo(() => {
    if (objectList.length <= 0) return [];
    if (selectedObjectType === 'entity')
      return objectList.filter((object) => object.isEntity);
    if (selectedObjectType === 'object')
      return objectList.filter((object) => !object.isEntity);
    return objectList;
  }, [objectList, selectedObjectType]);

  const socialProfileObjList = useMemo(() => {
    return filteredObjectsByType.filter((obj) => {
      return obj.streamType === 'account' && obj.socialMedia !== 'googleReview';
    });
  }, [filteredObjectsByType]);

  const objectListKeywordAndHashtag = useMemo((): Array<IObject> => {
    return filteredObjectsByType.filter(
      (object) => object.streamType === 'keyword'
    );
  }, [filteredObjectsByType]);

  return (
    <Stack>
      <SectionSocialProfile
        objectList={socialProfileObjList}
        objectListIdActive={selectedSocialProfileIds}
        // onParentVisible={() => setHide((prev) => !prev)}
        onSelect={(socialProfileIds) =>
          dispatch(reducerUpdateTempSelectedSocialProfiles(socialProfileIds))
        }
      />
      <SectionKeywordHashtag
        objectList={objectListKeywordAndHashtag}
        objectListIdActive={selectedKeywordIds}
        // onParentVisible={() => setHide((prev) => !prev)}
        onSelect={(keywordAndHashtagIds) =>
          dispatch(reducerUpdateTempSelectedKeywords(keywordAndHashtagIds))
        }
      />
    </Stack>
  );
};

export default SelectObjectSection;
